import React from "react";
import { Modal } from "antd";

const ModalView = (props) => {
    return (
        <Modal
            title={props.title}
            visible={props.visible}
            onCancel={props.onCancel}
            width={props.width ? props.width : 800}
            footer={[]}
        >
            {props.render()}
        </Modal>
    );
};

export default ModalView;
